import { render } from "./Organizations.vue?vue&type=template&id=2ca849a5&scoped=true&ts=true"
import script from "./Organizations.vue?vue&type=script&lang=ts"
export * from "./Organizations.vue?vue&type=script&lang=ts"

import "./Organizations.vue?vue&type=style&index=0&id=2ca849a5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ca849a5"]])

export default __exports__